<template>
  <div>
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin-bottom:40px"
    >
      <el-breadcrumb-item :to="{ path: '/userTab' }"
        >企业信息</el-breadcrumb-item
      >
      <el-breadcrumb-item>合作伙伴认证</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div class="xingxi">
        <div class="tiao"></div>
        <i>数据处理合作伙伴认证</i>
      </div>
      <div class="biaodan">
        <el-form
          label-position="top"
          label-width="80px"
          :model="userForm"
          ref="userForm"
          :rules="userRules"
          :hide-required-asterisk="hide"
        >
          <el-form-item label="软件产品型号：" prop="software">
            <el-select
              v-model="userForm.software"
              placeholder="请选择"
              multiple
              filterable
              allow-create
              default-first-option
            >
              <el-option label="PhotoMesh" value="PhotoMesh"></el-option>
              <el-option label="无人机管家" value="无人机管家"></el-option>
              <el-option label="LiDAR360" value="LiDAR360"></el-option>
              <el-option label="INPHO" value="INPHO"></el-option>
              <el-option label="Pix4DMapper" value="Pix4DMapper"></el-option>
              <el-option label="Smart3D" value="Smart3D"></el-option>
              <el-option
                label="Context Capture"
                value="Context Capture"
              ></el-option>
              <el-option
                label="PotoScanAltizure"
                value="PotoScanAltizure"
              ></el-option>
              <el-option
                label="Pixel Factory"
                value="Pixel Factory"
              ></el-option>
            </el-select>
          </el-form-item>
          <b style="font-size: 12px;"
            >注：如选项框中没有相应软件产品型号可手动输入按回车添加</b
          >
          <!-- <el-input v-model="userForm.Email" style="width:320px"></el-input> -->
          <el-form-item label="电子邮箱：" prop="Email">
            <el-input
              type="textarea"
              autosize
              v-model="userForm.Email"
            ></el-input>
          </el-form-item>
        </el-form>
        <div v-if="this.bohuizhuantai">
          <div>
            <i style="color: #f56c6c;" class="bitianshangchuan"> 驳回原因：</i>
          </div>
          <el-input
            :disabled="true"
            :rows="4"
            type="textarea"
            v-model="userForm.chulibohui"
          ></el-input>
        </div>
      </div>
      <div class="btn">
        <el-button type="primary" @click="submission()">提交确认</el-button>
      </div>
    </el-card>
  </div>

  <!-- <el-row>
    <el-col :span="2" style="height:10px"> </el-col>
    <el-col :span="20">
      
    </el-col>
    <el-col :span="2" style="height:10px"> </el-col>
  </el-row> -->
</template>

<script>
export default {
  data() {
    return {
      bohuizhuantai: false,
      userForm: {
        software: "",
        Email: "",
        chulibohui: ""
      },
      //检验规则
      userRules: {
        software: [
          { required: true, message: "请选择软件产品型号", trigger: "change" }
        ],
        Email: [{ required: true, message: "请输入邮箱地址", trigger: "blur" }]
      },
      hide: true,
      //添加属性
      udate: {
        function: "t_user",
        id: "",
        jsonData: { data: "" }
      },

      //上传认证
      companydate: {
        type: 3,
        userJsonData: { data: {} }
      },
      application: {
        host: "parallelword@terra-it.cn",

        title: "平行世界",
        content: ""
      }
    };
  },
  created() {
    this.sessionData();
  },
  methods: {
    async submit() {
      var content = `平行世界有合作伙伴认证待处理`;
      this.application.content = content;
      const { data: dt } = await this.$http.post(
        "general/sendMail",
        this.application
      );
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
    },
    //获取session中数据
    async sessionData() {
      let config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      const { data: dt } = await this.$http.post(
        "user/getUserInfo",
        "",
        config
      );
      if (dt.status == 500) {
        this.$confirm("身份认证过期请重新登陆", "退出", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.sessionStorage.removeItem("token");
            // window.sessionStorage.removeItem("tempData");
            this.$router.push("/login");
          })
          .catch(() => {});
        // return this.$message.error("身份认证过期请重新登陆");
      }
      this.testData = dt.data;
      this.testData.auth.forEach(e => {
        if (e.type == 3) {
          if (e.status == 2) {
            this.bohuizhuantai = true;
          }
        }
      });
      this.udate.id = this.testData.id;
      if (this.testData.hasOwnProperty("data")) {
        this.testData.data = JSON.parse(this.testData.data);
        if (this.testData.data.hasOwnProperty("chulibohui")) {
          this.userForm.chulibohui = this.testData.data.chulibohui;
        }
        if (this.testData.data.hasOwnProperty("software")) {
          this.userForm.software = this.testData.data.software.split(",");
        }
        if (this.testData.data.hasOwnProperty("Email")) {
          this.userForm.Email = this.testData.data.Email;
        }
      }
    },
    //提交请求
    submission() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          this.$confirm("确认要提交认证么?", "提交", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(async () => {
              this.testData.data.software = this.userForm.software.toString();
              this.testData.data.Email = this.userForm.Email;
              this.companydate.userJsonData.data = this.testData.data;
              this.companydate.userJsonData.data = JSON.stringify(
                this.companydate.userJsonData.data
              );
              this.companydate.userJsonData = JSON.stringify(
                this.companydate.userJsonData
              );
              const { data: dt } = await this.$http.post(
                "user/auth",
                this.companydate
              );
              if (dt.status == 500) {
                this.$confirm("身份认证过期请重新登陆", "退出", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                })
                  .then(() => {
                    window.sessionStorage.removeItem("token");
                    // window.sessionStorage.removeItem("tempData");
                    this.$router.push("/login");
                  })
                  .catch(() => {});
                // return this.$message.error("身份认证过期请重新登陆");
              }
              if (dt.status !== 200) {
                return this.$message.error(dt.msg);
              }
              this.submit();
              this.$message({
                message: "提交成功",
                type: "success"
              });

              this.$router.push("/users");
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.el-select {
  width: 320px;
}
i {
  font-style: normal;
}

.el-card {
  // width: 100%;
  height: 70vh;
  position: relative;
  // overflow: auto;
  margin-bottom: 30px;
  .xingxi {
    // width: 180px;
    // position: absolute;
    // left: 50px;
    // top: 60px;
    margin-top: 20px;
    margin-bottom: 20px;
    .tiao {
      width: 4px;
      height: 15px;
      background: rgba(0, 134, 253, 1);
      display: inline-block;
      margin-right: 10px;
    }
    i {
      // width: 65px;
      font-weight: bold;
      font-size: 16px;
    }
  }
  // .biaodan {
  //   // height: 342px;
  //   // position: absolute;
  //   // top: 150px;
  //   // left: 80px;
  // }
  .btn {
    text-align: center;
    position: absolute;
    bottom: 10px;
    left: 50%;

    transform: translateX(-50%);
  }
  .el-button {
    width: 260px;
    height: 50px;
    // position: absolute;
    // left: 50%;
    // top: 750px;
    // transform: translateX(-50%);
  }
}
</style>
